/* eslint-disable */
exports.install = function (Vue, options) {

  //获取当前年月日
  Vue.prototype.getDay = function (day) {//全局函数1
    var today = new Date();
    var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
    today.setTime(targetday_milliseconds); //注意，这行是关键代码

    var tYear = today.getFullYear();
    var tMonth = today.getMonth();
    var tDate = today.getDate();
    tMonth = doHandleMonth(tMonth + 1);
    tDate = doHandleMonth(tDate);
    return tYear + "-" + tMonth + "-" + tDate;

    function doHandleMonth(month) {
      var m = month;
      if (month.toString().length == 1) {
        m = "0" + month;
      }
      return m;
    }

  };

  //写cookies  过期时间 2小时后
  //expiretimes =1 代表1分钟
  Vue.prototype.setCookie = function (c_name, value, expiretimes) {
    //统一设为60分钟
    var expiretimes = 60
    var exdate = new Date();
    exdate.setTime(exdate.getTime() + (expiretimes * 60 * 1000));
    console.log(exdate);  //Tue Nov 05 2019 21:21:26 GMT+0800 (中国标准时间)
    console.log(exdate.toGMTString());   //Tue, 05 Nov 2019 13:21:26 GMT
    //相差8小时
    document.cookie = c_name + "=" + escape(value) + ";path=/" + ((expiretimes == null) ? "" : ";expires=" + exdate.toGMTString());
  }

  //读取cookies  
  Vue.prototype.getCookie = function (name) {
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg))
      return (arr[2]);
    else
      return null;
  }

  //生成唯一机器码
  Vue.prototype.uuid = function () {
    var timestamp = (new Date()).getTime();

    return parseInt(timestamp / 1000);
  }
};